// import "core-js/stable";
// import "@stimulus/polyfills";
import { Application } from "stimulus";
// import Turbolinks from "turbolinks";

// Turbolinks.start();
// FIXME: this is breaking js from rendering
// Turbolinks.setProgressBarDelay(100);

if (!window.StimulusApplication) {
  window.StimulusApplication = Application.start();
}
export default window.StimulusApplication;
